// extracted by mini-css-extract-plugin
module.exports = {"description":"a10a3f92e9--description--2vxkC"};